module.exports = __webpack_public_path__ + "img/partner20.7800edc0.jpg";